import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { LayoutGrid, ShieldCheck } from 'lucide-react';
import HubDashboard from './HubDashboard';
import { HubSearch } from './HubSearch';

const ProfileHubsSection = ({ profileType }) => {
  const { api, user } = useAuth();
  const isAdmin = !!user?.is_admin;
  const [profiles, setProfiles] = useState([]);
  const [ownProfile, setOwnProfile] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get('/platform/profiles').then((r) => setProfiles(r.data.profiles || [])).catch(() => setProfiles([]));
    api.get('/platform/user/preferences')
      .then((r) => setOwnProfile(r.data.profile_type || 'persona_natural'))
      .catch(() => setOwnProfile('persona_natural'));
  }, [api]);

  useEffect(() => {
    const p = profileType || ownProfile;
    if (p) setActive(p);
  }, [profileType, ownProfile]);

  const visible = isAdmin ? profiles : profiles.filter((p) => p.type === active);

  return (
    <section data-testid="profile-hubs-section" className="mb-6 md:mb-8 rounded-2xl border border-slate-800 bg-slate-900/60 p-4 md:p-6">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <LayoutGrid className="w-5 h-5 text-blue-400" />
        <h2 className="text-base md:text-lg font-semibold font-['Outfit'] text-white">
          {isAdmin ? 'Hubs por perfil' : 'Mis Hubs'}
        </h2>
        {isAdmin && (
          <span data-testid="hubs-admin-badge" className="inline-flex items-center gap-1 rounded-full bg-red-500/15 border border-red-500/40 px-2 py-0.5 text-xs font-semibold text-red-300">
            <ShieldCheck className="w-3 h-3" /> Admin · acceso total
          </span>
        )}
      </div>
      <p className="text-sm text-slate-400 mb-4">
        {isAdmin
          ? 'Como administrador ves los Hubs de todos los perfiles. Elige una pestaña para verlos.'
          : 'Los módulos disponibles para tu tipo de perfil.'}
      </p>
      {isAdmin && <HubSearch profiles={profiles} />}
      <div className="flex flex-wrap gap-2 mb-6" role="tablist">
        {visible.map((p) => (
          <button
            key={p.type}
            role="tab"
            aria-selected={active === p.type}
            data-testid={`hubs-tab-${p.type}`}
            onClick={() => setActive(p.type)}
            className={`rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${
              active === p.type
                ? 'bg-blue-600 border-blue-500 text-white'
                : 'border-slate-700 text-slate-300 hover:bg-slate-800'
            }`}
          >
            {p.icon} {p.name} <span className="opacity-70">({p.hub_count})</span>
          </button>
        ))}
      </div>
      {active && <HubDashboard key={active} profileType={active} />}
    </section>
  );
};

export default ProfileHubsSection;
